var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 161"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 241",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 102",
    x1: 8,
    y1: 13,
    x2: 18,
    y2: 13,
    stroke: "white",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/DeleteButton.b4a9b5eb3a8378dab72caff6c2ee9879.svg";
export { ForwardRef as ReactComponent };